/**
 * Register the service worker from the page. The worker is emitted at the stable root URL
 * `/sw.js` with root scope so it controls the whole install origin. Registration failures are
 * swallowed to a warning — a browser without service-worker support (or a private-mode tab)
 * must still get a working, if non-offline, app.
 */
export const registerServiceWorker = (): void => {
  if (!('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/', type: 'module' }).catch((error: unknown) => {
      console.warn('[vn-pwa] service worker registration failed', error)
    })
  })
}
